import React from 'react'
import PropTypes from 'prop-types'
import { Colors } from '../../global'

const sizes = {
  xxl: {
    width: 128,
  },
  xl: {
    width: 64,
  },
  lg: {
    width: 48,
  },
  md: {
    width: 32,
  },
  sm: {
    width: 24,
  },
  s22: {
    width: 22,
  },
  s20: {
    width: 20,
  },
  s18: {
    width: 18,
  },
  xs: {
    width: 16,
  },
  s10: {
    width: 10,
  },
  xxs: {
    width: 8,
  },
  xxxs: {
    width: 4,
  },
}

const Icon = ({ svg: Svg, size, width, aspect, color, style, ...rest }) => {
  if(Array.isArray(style)) style = Object.assign({}, ...style)
  return (
    <Svg
      {...rest}
      //style={{ backgroundColor: 'red' }}
      width={width ? width : sizes[size].width}
      height={width ? width * aspect : sizes[size].width * aspect}
      color={color}
    />
  )
}

Icon.defaultProps = {
  size: 'md',
  color: Colors.primary,
  aspect: 1,
}

Icon.propTypes = {
  svg: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['xxxs','xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl','s18','s20','s10','s22']),
  aspect: PropTypes.number,
}

export default Icon
